<template>
  <div>
    <titleBar :title="title" :param="$route.query"/>
    <div class="jc-page-content couponLoading">
      <div class="money-top clearfix ">
        <h3 class="money-h3">
          <span class="money-ttit">{{ $t('可用券额') }}</span>
        </h3>
        <div class="money-numw fl top-front-wrap">
          <div class="money-num">
            <strong class="money-strong">{{quota | formatMoney}}</strong> {{ $t('元') }}
          </div>
          <jc-button type="primary" v-if='deliverPermission' @click="deliverCoupon">{{ $t('发放代金券') }}</jc-button>
        </div>
        <div class="top-behind-wrap">
          <dl class="cash-expw-dl">
            <dt>{{ $t('提示') }}</dt>
            <dd>1.{{ $t('券额是指可以用于发放代金券的额度，券额的有效期为自发放之日起1年，逾期作废。') }}</dd>
            <dd>{{ $t('2_如果已经发放的代金券禁用之后会将剩余金额自动返还到券额里_') }}</dd>
          </dl>
        </div>
      </div>
      <div class="item-tab jc-container-table" >
        <jc-tabs v-model="recordType" :active-name="recordType">
          <jc-tab-pane :label="$t('额度记录')" name="quotaRecord">
            <div class="jc-container-table-actionBar mb20">
              <span class="searchGroup">
              <label class="form-tablelabel">
                <span>{{ $t('操作类型_') }}</span>
                <jc-select :placeholder="$t('请选择')" style="width:120px;" v-model="quotaSearchParams.operationTypeIndex">
                    <jc-option v-for="(item,index) in staticData.couponsType" :key="index" :label="item.label" :value="item.value"></jc-option>
                </jc-select>
              </label>
              <label class="form-tablelabel">
                <span>{{ $t('操作时间_') }}</span>
                <jc-date-picker type="daterange" style="width:200px;" v-model="quotaSearchParams.operationTime"></jc-date-picker>
              </label>
              <label class="form-tablelabel">
                  <span>{{ $t('代金券编号_') }}</span>
                  <jc-input  style="width:120px;" v-model="quotaSearchParams.couponNumber"></jc-input>
              </label>
              </span>

              <span class="searchGroup">
              <label class="form-tablelabel">
                  <span>{{`${$t('领取账号')}${$t('：')}`}}</span>
                  <jc-input style="width:120px;" v-model="quotaSearchParams.couponPin"></jc-input>
              </label>
              <jc-button type="primary" @click="getQuotaRecord">{{ $t('查询') }}</jc-button>
            </span>
            </div>
            <jc-table class="quotaLoading" :data="quotaList">
              <jc-table-column :label="$t('操作类型')" min-width="10">
                <template scope="scope" >{{scope.row.operationTypeIndex | getOpTypeName}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('时间')" min-width="17" prop="updateTime"></jc-table-column>
              <jc-table-column :label="$t('额度变动')" min-width="10">
                <template scope="scope" >{{Number(scope.row.value)>0?'+':''}}{{scope.row.value | formatMoney}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('可用券额_元_')" min-width="12">
                <template scope="scope" >{{scope.row.quotaBalance | formatMoney}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('代金券金额_元_')" min-width="12">
                <template scope="scope" >{{scope.row.fee | formatMoney}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('代金券余额_元_')" min-width="12">
                <template scope="scope" >{{scope.row.balance | formatMoney}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('代金券编码')" min-width="12" prop="couponNumber"></jc-table-column>
              <jc-table-column :label="$t('领取账号')" min-width="14" prop="couponPin"></jc-table-column>
            </jc-table>
            <div class="jc-container-table-actionBar">
              <jc-pagination align="right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="quotaSearchParams.currentPage"
                :page-sizes="[10, 20,50]"
                :page-size="quotaSearchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="quotaTotal">
              </jc-pagination>
            </div>
          </jc-tab-pane>
          <jc-tab-pane :label="$t('发放记录')" name="grantRecord">
            <div class="jc-container-table-actionBar mb20">
              <span class="searchGroup">
              <label class="form-tablelabel">
                  <span>{{ $t('代金券编码_') }}</span>
                  <jc-input style="width:120px;" v-model="grantSearchParams.number"></jc-input>
              </label>
              <label class="form-tablelabel">
                <span>{{ $t('代金券有效时间_') }}</span>
                <jc-date-picker type="daterange" style="width:160px;" v-model="grantSearchParams.validTime"></jc-date-picker>
              </label>
              <label class="form-tablelabel">
                <span>{{ $t('发放时间_') }}</span>
                <jc-date-picker type="daterange" style="width:160px;" v-model="grantSearchParams.grantTime"></jc-date-picker>
              </label>
              </span>
              <span class="searchGroup">
              <label class="form-tablelabel">
                <span>{{`${$t('领取账号')}${$t('：')}`}}</span>
                <jc-input style="width:120px;" v-model="grantSearchParams.pin"></jc-input>
              </label>
              <label class="form-tablelabel">
                <span>{{ $t('状态_') }}</span>
                <jc-select :placeholder="$t('请选择')" style="width:120px;" v-model="grantSearchParams.statusIndex">
                    <jc-option v-for="(item,index) in staticData.couponStatus" :key="index" :label="item.label" :value="item.value"></jc-option>
                </jc-select>
              </label>
              <jc-button type="primary" @click="getGrantRecord">{{ $t('查询') }}</jc-button>
              </span>
              <!-- <a href="#" class="download-icon-v1 fr" @click.prevent="exportecord" style="margin-top:9px;"></a> -->
            </div>
            <jc-table class="grantLoading" :data="grantList">
              <jc-table-column :label="$t('代金券编码')" :min-width="'11'" prop="number"></jc-table-column>
              <jc-table-column :label="$t('金额_元_')" :min-width="'9'">
                <template scope="scope" >{{scope.row.fee | formatMoney}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('余额_元_')" :min-width="'9'">
                <template scope="scope" >{{scope.row.balance | formatMoney}}</template>
              </jc-table-column>
             <jc-table-column :label="$t('代金券有效时间')" width="180">
                <template scope="scope" >{{ scope.row.validStartTime + $t('至')}}<br/>{{scope.row.validEndTime}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('领取账号')" min-width="12" prop="pin"></jc-table-column>
              <jc-table-column :label="$t('发放时间')" width="90" prop="createTime">
                <template scope="scope" >{{scope.row.createTime}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('状态')" min-width="8" prop="statusIndex">
                <template scope="scope" >{{scope.row.statusIndex | getCouponStatus}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('计费方式')" min-width="10" prop="billingType" :show-overflow-tooltip='true'>
                <template scope="scope" >
                  {{scope.row.billingType | filterBillingType}}</template>
              </jc-table-column>
              <jc-table-column   :label="$t('支持地域')" min-width="10" :show-overflow-tooltip='true'>
                <template slot-scope="scope" >
                  {{scope.row.region | filterRegion}}
                </template>
              </jc-table-column>
              <jc-table-column :label="$t('产品线')" min-width="12" prop="appCode" :show-overflow-tooltip='true'>
                <template scope="scope" >
                  {{scope.row | filterAppcode}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('操作')" min-width="10" prop="" v-if='deliverPermission'>
                <!-- <template scope="scope" ><jc-button type="text"   @click="showDisableDialog(scope.row)">{{$t('禁用')}}</jc-button></template>  -->
                <template scope="scope" ><jc-button type="text"  class="textBreak" @click="showDisableDialog(scope.row)" :disabled="scope.row.isExpired || scope.row.statusIndex !== 3">{{$t('禁用')}}</jc-button></template>

              </jc-table-column>
            </jc-table>
            <div class="jc-container-table-actionBar">
              <jc-pagination align="right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="grantSearchParams.currentPage"
                :page-sizes="[10, 20,50]"
                :page-size="grantSearchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="grantTotal">
              </jc-pagination>
            </div>
          </jc-tab-pane>
        </jc-tabs>
      </div>
    </div>
    <!--禁用弹窗-->
    <jc-dialog
      :title="$t('禁用代金券')"
      :visible.sync="disableShow"
      @close="resetForm('disableCoupon')"
      :modal-append-to-body='false' :close-on-click-modal="false"
      size="tiny">
      <jc-form label-width="120px" ref="disableCoupon" :model='disableForm' :rules='disableRules'>
        <jc-form-item :label="$t('禁用原因：')" prop='disableReason'>
          <jc-input type="textarea" v-model.trim='disableForm.disableReason' :maxlength=500 :rows="4"></jc-input>
        </jc-form-item>
      </jc-form>
      <span slot="footer" class="dialog-footer">
        <jc-button v-loading='disableLoading'  type="primary" @click="disableCoupon()">{{$t('确定')}}</jc-button>
        <jc-button @click="disableShow = false">{{$t('关闭')}}</jc-button>
      </span>
    </jc-dialog>
  </div>
</template>

<script>
import getTranslation from '@/i18n/getTranslation'

import titleBar from '@/components/titleBar'
import { BILLING_TYPE_MAP } from '@/utils/constant.js'
import { getDate } from '@/utils'
import {
  queryQuota,
  queryQuotaRecordList,
  queryCouponList,
  disableCoupons
  // exportCouponList
} from '@/api/coupon-api.js'
export default {
  name: 'couponManage',
  filters: {
    getOpTypeName(_val) {
      switch (_val) {
        case 1:
          return getTranslation('发放代金券')
        case 2:
          return getTranslation('禁用代金券')
        case 3:
          return getTranslation('代金券过期')
        case 4:
          return getTranslation('券额变更')
      }
    },

    getCouponStatus(_val) {
      switch (_val) {
        case 1:
          return getTranslation('生成中')
        case 2:
          return getTranslation('禁用')
        case 3:
          return getTranslation('启用')
        case 4:
          return getTranslation('未激活')
      }
    },

    formatTime(_val) {
      let _date = new Date(_val),
        _y = _date.getFullYear(),
        _m = _date.getMonth() + 1,
        _d = _date.getDate(),
        _h = _date.getHours(),
        _mn = _date.getMinutes(),
        _s = _date.getSeconds()
      _m = _m < 10 ? '0' + _m : _m
      _d = _d < 10 ? '0' + _d : _d
      _h = _h < 10 ? '0' + _h : _h
      _mn = _mn < 10 ? '0' + _mn : _mn
      _s = _s < 10 ? '0' + _s : _s
      return _y + '-' + _m + '-' + _d + ' ' + _h + ':' + _mn + ':' + _s
    },

    formatApp(_val) {
      _val = _val ? _val : ''
      _val = _val.charAt(0) == '|' ? _val.substring(1) : _val
      _val =
        _val.charAt(_val.length - 1) == '|'
          ? _val.substring(0, _val.length - 1)
          : _val
      return _val
    },

    filterAppcode(row) {
      let appName = ''
      appName = ''
      let aN = row.appName.split(',')
      aN &&
        aN.map(item => {
          appName += getTranslation(item) + ','
        })
      appName = appName.substring(0, appName.length - 1)
      return appName
    }
  },

  data() {
    return {
      title: getTranslation('券额管理'),
      recordType: 'quotaRecord',
      couponLoading: false,
      quotaLoading: false,
      grantLoading: false,
      staticData: {
        couponsType: [
          { label: getTranslation('全部'), value: 0 },
          { label: getTranslation('发放代金券'), value: 1 },
          { label: getTranslation('禁用代金券'), value: 2 },
          // { label: getTranslation('代金券过期'), value: 3 },
          { label: getTranslation('券额变更'), value: 4 }
        ],
        couponStatus: [
          { label: getTranslation('全部'), value: 0 },
          { label: getTranslation('生成中'), value: 1 },
          { label: getTranslation('禁用'), value: 2 },
          { label: getTranslation('启用'), value: 3 }
          //{label: "未激活", value: 4}
        ]
      },
      quota: 0,
      quotaSearchParams: {
        operationTypeIndex: 0, //操作类型
        operationTime: null, //操作时间
        couponNumber: null, //代金券编码
        couponPin: null, //代金券领取人
        currentPage: 1, //当前页
        pageSize: 10, //页大小
        totalCount: 0
      },
      grantSearchParams: {
        validTime: null, //有效时间
        grantTimeEnd: null, //发行时间
        number: null, //代金券编码
        pin: null, //代金券领取人
        statusIndex: 0, //代金券状态
        currentPage: 1, //当前页
        pageSize: 10, //页大小
        totalCount: 0
      },
      quotaList: [],
      grantList: [],
      quotaTotal: 0,
      grantTotal: 0,
      exportGrantRecordUrl: '',
      deliverPermission: false, // 是否具有发放权限
      BILLING_TYPE_MAP,
      disableShow: false,
      disableForm: {
        disableReason: '',
        ids: ''
      },
      disableLoading: false,
      disableRules: {
        disableReason: [
          { required: true, message: '请输入禁用原因', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    titleBar
  },
  watch: {
    recordType(_val) {
      _val == 'quotaRecord' ? this.getQuotaRecord() : this.getGrantRecord()
    }
  },
  methods: {
    handleSizeChange: function(_val) {
      if (this.recordType == 'quotaRecord') {
        this.quotaSearchParams.currentPage = 1
        this.quotaSearchParams.pageSize = _val
        this.getQuotaRecord()
      }
      if (this.recordType == 'grantRecord') {
        this.grantSearchParams.currentPage = 1
        this.grantSearchParams.pageSize = _val
        this.getGrantRecord()
      }
    },

    handleCurrentChange: function(_val) {
      if (this.recordType == 'quotaRecord') {
        this.quotaSearchParams.currentPage = _val
        this.getQuotaRecord()
      }
      if (this.recordType == 'grantRecord') {
        this.grantSearchParams.currentPage = _val
        this.getGrantRecord()
      }
    },

    async queryFun(_url, _params, _loading, _callback) {
      try {
        let _result = await _url(_params)
        if (_loading) this[_loading] = false
        _result = _result.body
        if (_result.code == 0) {
          _callback(_result.result)
        } else {
          this.$notify({
            message: _result.message,
            type: 'error'
          })
        }
      } catch (err) {
        if (_loading) this[_loading] = false
        this.$notify({
          message: getTranslation('数据加载失败'),
          type: 'error'
        })
      }
    },

    getCanUseCoupon() {
      this.couponLoading = true
      this.queryFun(queryQuota, {}, 'couponLoading', _result => {
        if (_result.permission == 0 || _result.permission == 2) {
          this.$alert(
            getTranslation('您没有权限查询查看券额管理页面'),
            getTranslation('提示')
          )
            .then(() => {
              this.$router.push({ path: '/cost/coupon' })
            })
            .catch(() => {
              this.$router.push({ path: '/cost/coupon' })
            })
        } else {
          this.quota = _result.data
          this.deliverPermission =
            Number(_result.permission) == 3 ? true : false
        }
      })
    },

    getQuotaRecord() {
      // let that = this
      this.quotaLoading = true
      let _params = {}
      if (
        this.quotaSearchParams.operationTypeIndex &&
        this.quotaSearchParams.operationTypeIndex !== 0
      )
        _params.operationTypeIndex = this.quotaSearchParams.operationTypeIndex
      if (this.quotaSearchParams.operationTime) {
        _params.operationTimeBegin = getDate(
          this.quotaSearchParams.operationTime[0],
          '-'
        ).ymd
        _params.operationTimeEnd = getDate(
          this.quotaSearchParams.operationTime[1],
          '-'
        ).ymd
      }
      if (this.quotaSearchParams.couponNumber)
        _params.couponNumber = this.quotaSearchParams.couponNumber
      if (this.quotaSearchParams.couponPin)
        _params.couponPin = this.quotaSearchParams.couponPin
      _params.currentPage = this.quotaSearchParams.currentPage
      _params.pageSize = this.quotaSearchParams.pageSize
      this.queryFun(queryQuotaRecordList, _params, 'quotaLoading', _result => {
        this.quotaList = _result.data
        this.quotaTotal = _result.pageInfo.totalRecord
      })
    },

    getGrantRecord() {
      this.grantLoading = true
      let _params = {}
      if (
        this.grantSearchParams.validTime &&
        this.grantSearchParams.validTime[0]
      ) {
        _params.validTimeBegin =
          getDate(this.grantSearchParams.validTime[0], '-').ymd + ' 00:00:00'
        _params.validTimeEnd =
          getDate(this.grantSearchParams.validTime[1], '-').ymd + ' 23:59:59'
      } else {
        _params.validTimeBegin = ''
        _params.validTimeEnd = ''
      }
      if (
        this.grantSearchParams.grantTime &&
        this.grantSearchParams.grantTime[0]
      ) {
        _params.createTimeBegin =
          getDate(this.grantSearchParams.grantTime[0], '-').ymd + ' 00:00:00'
        _params.createTimeEnd =
          getDate(this.grantSearchParams.grantTime[1], '-').ymd + ' 23:59:59'
      } else {
        _params.createTimeBegin = ''
        _params.createTimeEnd = ''
      }
      if (this.grantSearchParams.number)
        _params.number = this.grantSearchParams.number
      if (this.grantSearchParams.pin) _params.pin = this.grantSearchParams.pin
      if (
        this.grantSearchParams.statusIndex &&
        this.grantSearchParams.statusIndex !== 0
      )
        _params.statusIndex = this.grantSearchParams.statusIndex
      _params.currentPage = this.grantSearchParams.currentPage
      _params.pageSize = this.grantSearchParams.pageSize
      this.queryFun(queryCouponList, _params, 'grantLoading', _result => {
        this.grantList = this.handleTableData(_result.data)
        this.grantTotal = _result.pageInfo.totalRecord
      })
    },
    /**
     * @event 处理禁用的状态，过期不允许禁用
     */
    handleTableData(data) {
      let isExpired = false
      data &&
        data.map(item => {
          let date =
            item.validEndTime &&
            new Date(item.validEndTime) &&
            new Date(item.validEndTime).getTime()
          isExpired = Date.now() > date || !(item.balance >= 0.01)
          item.isExpired = isExpired
        })
      return data
    },
    // async exportecord() {
    //   let params = Object.assign({}, this.grantSearchParams)
    //   if (params.statusIndex === 0) params.statusIndex = null
    //   let { body } = await exportCouponList(params)
    //   window.open(body && body.result, '_blank')
    // },
    // 跳转到发放代金券页面
    deliverCoupon() {
      this.$router.push({ path: '/cost/issue-coupon' })
    },
    showDisableDialog(row) {
      this.disableForm.ids = row.id
      this.disableShow = true
    },
    async disableCoupon() {
      this.$refs['disableCoupon'].validate(async valid => {
        if (valid) {
          this.disableLoading = true
          try {
            let { body } = await disableCoupons(this.disableForm)
            this.$notify({
              message:
                getTranslation(body.result && body.result.message) ||
                getTranslation('禁用成功'),
              type: 'success'
            })
            this.getGrantRecord()
          } finally {
            this.disableLoading = false
            this.disableShow = false
          }
        }
      })
    },
    resetForm(ruleForm) {
      setTimeout(() => {
        this.$refs[ruleForm].resetFields()
      }, 10)
    }
  },
  created: function() {
    this.getCanUseCoupon()
    this.recordType == 'quotaRecord'
      ? this.getQuotaRecord()
      : this.getGrantRecord()
  }
}
</script>

<style scoped="true">
.form-tablelabel {
  margin-right: 10px;
}
.exportIframe {
  position: absolute;
  left: -100px;
  bottom: -100px;
  width: 0;
  height: 0;
}
.searchGroup {
  display: inline-block;
  margin-top: 8px;
}
.textBreak {
  white-space: normal;
  word-break: break-all;
}
</style>
